module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "topnavi"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".in",
      "to": "/profile/"
    }
  }, [_c('i', {
    staticClass: "fa fa-user fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Profil")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".in",
      "to": "/logout/"
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Abmelden")])])], 1)])]), _vm._v(" "), _c('nav', {
    staticClass: "mainnav",
    attrs: {
      "id": "mainmenu"
    }
  }, [_c('ul', {
    staticClass: "fried-collapsed"
  }, [_c('li', {
    staticClass: "menu-icon"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.toggleMenu('mainmenu', 'mainnav', 'mainnav fullnav', 'main-content') || this.blur()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-lg fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Menü")])])]), _vm._v(" "), (_vm.hasDashboard) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".in",
      "to": "/dashboard/"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard fa-lg fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Dashboard")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasCustomers) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".in",
      "to": "/customers/"
    }
  }, [_c('i', {
    staticClass: "fa fa-users fa-lg fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Kunden")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasDeceaseds) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".in",
      "to": "/deceaseds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus fa-lg fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Verstorbene")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasGraves) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".in",
      "to": "/graves/"
    }
  }, [_c('i', {
    staticClass: "fa fa-battery-quarter fa-lg fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Gräber")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasAreas) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".in",
      "to": "/areas/"
    }
  }, [_c('i', {
    staticClass: "fa fa-object-group fa-lg fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Flächen")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasUndertakers) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".in",
      "to": "/undertakers/"
    }
  }, [_c('i', {
    staticClass: "fa fa-male fa-lg fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Bestatter")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasCrematories) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".in",
      "to": "/crematories/"
    }
  }, [_c('i', {
    staticClass: "fa fa-fire fa-lg fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Krematorien")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasSettings) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.toggleMenu('settings-menu')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog fa-lg fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Einstellungen")])]), _vm._v(" "), _c('ul', {
    staticClass: "submenu-collapsed",
    attrs: {
      "id": "settings-menu"
    }
  }, [(_vm.hasAreaCategories) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/area_types/"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Flächenarten")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasGraveCategories) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/grave_types/"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Grabarten")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasBurialTypes) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/burial_types/"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Bestattungsarten")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasDenominations) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/denominations/"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Konfessionen")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasUsers) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/users/"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Benutzer")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasRoles) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/roles/"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Rollen")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasGraveyards) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.setClass('mainmenu', 'mainnav')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/graveyards/"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "nav-name"
  }, [_vm._v("Friedhöfe")])])], 1) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friedmap-logo"
  }, [_c('img', {
    staticStyle: {
      "width": "40px",
      "height": "40px"
    },
    attrs: {
      "src": "/img/gis_logo_v2.png",
      "alt": "dafuq"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d03158c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NaviView.vue
// module id = 438
// module chunks = 0